import { LiveContext } from "@amzn/aws-tc-xb-xps";
import { PropsWithChildren } from "react";
import { useConfig } from "../hooks";

// Config values should be defined in the file they are consumed.
// xbAppName is consumed outside of root utils so we define it here
export interface LiveContextProviderConfig {
  xbAppName: string;
}

export const Tier0LiveContextProvider = ({ children }: PropsWithChildren) => {
  const { xbAppName } = useConfig();
  return <LiveContext.Provider value={{ tier: 0, liveProps: {}, xbAppName }}>{children}</LiveContext.Provider>;
};
